/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Tickets_Updated_ColInputs */

const en_settings_tickets_updated_col = /** @type {(inputs: Settings_Tickets_Updated_ColInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Last Updated`)
};

const zh_settings_tickets_updated_col = /** @type {(inputs: Settings_Tickets_Updated_ColInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`更新时间`)
};

/**
* | output |
* | --- |
* | "Last Updated" |
*
* @param {Settings_Tickets_Updated_ColInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const settings_tickets_updated_col = /** @type {((inputs?: Settings_Tickets_Updated_ColInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Tickets_Updated_ColInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_tickets_updated_col(inputs)
	return zh_settings_tickets_updated_col(inputs)
});
export { settings_tickets_updated_col as "settings.tickets.updated_col" }